!function(window) {
const orderFunctions = function(lng) {

	var $productCodeFull = $('[name="other-product-code-full"]');
	var $productCode = $('[name="product-code"]');
	var $productName = $('[name="product-name"]');

	var $otherProductCntWrapper = $('.other-products-content-wrapper');
	var $discCntWrapper = $('.disc-content-wrapper');

	var $inputOrderNumber = $('[name="order-number"]');


	var $categorySelect = $('select#category');
	var $shadeSelect = $('select#shade');
	var $thicknessSelect = $('select#thickness');
	var $diameterSelect = $('select#diameter');
	var $borderSelect = $('select#border');

	setSelectionDropdownPanels();
		
	setTeethProgramArticleSwitch();

	setDiscDropdownsSwitch();

	setTableHighlight();

	setProductAutocomplete();

	setProductFilter();

	setDiscFilter();

	handleSaveToSession();

	clearAllFromSession();

	setInitialStateForIntro();

	setValidation();

	orderFinishForm();

	// intro page
	bindRemoveFromList();

	bindConfirmCancelOrder();

	clearAllFromSessionAndReload()

	otherProductsFilterShortcut();

	saveOrderNumber();

	changeDiscShadeOnCategorySwitch();


	function makeTableStickyHeader() {
		var $chessTable = $('.chess-table:not(.copy)');
		if ($chessTable.length) {
			var $chessCopy = $('.chess-table.copy');
			$(document).scroll(function(ev) {
				var scrollTop = $(document).scrollTop();
				var tableResponsive = $('.table-responsive').offset().top;
				if (scrollTop > tableResponsive) {
					$chessCopy.css('top', (scrollTop - tableResponsive)+'px');
				} else {
					$chessCopy.css('top', (scrollTop - tableResponsive)+'px');
				}
			});
		}
	}

	function changeDiscShadeOnCategorySwitch() {
		var $shade = $('.disc-filter-wrapper select#shade');
		var $thickness = $('.disc-filter-wrapper select#thickness');
		var $category = $('.disc-filter-wrapper select#category');
		$category.on('change', function(ev) {
			var categoryId = $(this).val();
			if (categoryId) {

				$category.attr('disabled', true);
				$shade.attr('disabled', true);
				$thickness.attr('disabled', true);

				var ajaxOpts = {
					func: 'get-disc-category-shades-thickness',
					categoryId: categoryId
				};
				$.post('/util/orderresponse.php?lng='+lng, ajaxOpts, function(data) {
					if (data) {
						$shade.html(data.shade);
						$thickness.html(data.thickness);

						$category.removeAttr('disabled');
						$shade.removeAttr('disabled');
						$thickness.removeAttr('disabled');
					}
				})
			}
		})
	}


	function saveOrderNumber() {
		$inputOrderNumber.on('blur', function(ev){
			var $input = $(this);
			var value = $input.val();

			var opts = {
				'func': 'save-to-session',
				'type': 'base',
				'data': {
					'id': 'order-number',
					'value': value
				}
			};

			if (value) {
				$.post('/util/orderresponse.php?lng='+lng, opts);
			}
		})
	}

	function otherProductsFilterShortcut() {
		$('[name="product-code"], [name="product-name"]').on('keydown', function (ev) {
			if (ev.keyCode == 13) {
				var options = {
					'func': 'filter-other-products',
					'product-name': $productCodeFull.val(),
					'product-code': $productCode.val()
				};
	
				$.post('/util/orderresponse.php?lng='+lng, options, function(data){
					$otherProductCntWrapper.html(data);
				});
			}
		});
	}

	// validateOrderNumber();

	$('.order-top-menu-extra-navigation .disabled').on('click', function(ev) {
		ev.preventDefault();
	})

	// function validateOrderNumber() {
	// 	$inputOrderNumber.on('keyup', function() {
	// 		updateSubmitAndCancelOrderBtn();
	// 	})
	// }

	function orderFinishForm() {
		$('#order-finish').on('click', function(ev) {
			ev.preventDefault();

			var $form = $('#order-finish-form');

			confirm($form, () => {
				$form.submit();
			});
		})
	}

	// bind confirm / cancel
	function bindConfirmCancelOrder() {
		$('#order-submit').on('click', function() {
			var $btn = $(this);

			confirm($btn, () => {

				var data = {};

				var url = $btn.attr('data-submit-url');
				$('.order-base-data').each(function(index, input) {
					var $input = $(input);
					data[$input.attr('name')] = $input.val();
				});

				var options = {
					'func': 'order-submit',
					'data': data
				};

				$.post('/util/orderresponse.php?lng='+lng, options, function(data) {
					window.location.href = url;
				})
			});
		});

		$('#order-cancel').on('click', function() {
			var $btn = $(this);
			confirm($btn, () => {
				var options = {
					'func': 'order-cancel'
				};

				$.post('/util/orderresponse.php?lng='+lng, options, function(data) {
					$('.session-list-no-content').removeClass('d-none');
					$('.session-list-has-content').addClass('d-none');
					$('.article-number').text(0);
					$btn.attr('disabled', true);
					$('#order-submit').attr('disabled', true);
					$('.order-base-data:not([readonly])').val('');
				})
			});
		})
	}

	function bindRemoveFromList() {
		$('[data-remove-from-list]').on('click', function(ev) {
			ev.preventDefault();
		
			var $btn = $(this);
			var $row = $(this).closest('tr');
			var $table = $row.closest('table');
			var $selectionContent = $table.closest('.selection-content');
			

			confirm($btn, () => {
				var id = $btn.attr('data-remove-from-list');
				var type = $btn.attr('data-type');
	
				var options = {
					'func': 'clear-from-session',
					'type': type,
					'id': id
				};
	
				$.post('/util/orderresponse.php?lng='+lng, options, function(data) {
					$row.remove();

					updateArticleNumber($selectionContent);
					updateSubmitAndCancelOrderBtn();
					var num = $table.find('.data-row').length;
					if (!num) {
						$selectionContent.find('.session-list-has-content').addClass('d-none');
						$selectionContent.find('.session-list-no-content').removeClass('d-none');
						$selectionContent.find('[data-clear-all-from-session]').attr('disabled', true);
					}
				});
			});

		
		
		});
	}


	function updateArticleNumber($selectionContent) {
		var type = $selectionContent.attr('data-selection-content');
		var $panel = $('[data-selection-anchor="'+type+'"]');
		var articleNum = 0;
		$selectionContent.find('.data-row .quantity-td').each(function(index, item) {
			var $item = $(item);
			articleNum += parseInt($item.text(), 10);
		});

		$panel.find('.article-number').text(articleNum);
	}


	function updateSubmitAndCancelOrderBtn() {
		var total = 0;

		$('.article-number').each(function(index, item) {
			total += parseInt($(item).text(), 10);
		});

		// if (!$inputOrderNumber.val()) {
		// 	$('#order-submit').attr('disabled', true);
		// 	if (total == 0) {
		// 		$('#order-cancel').attr('disabled', true);
		// 	}
		// 	return;
		// }

		if (total == 0) {
			$('#order-cancel').attr('disabled', true);
			$('#order-submit').attr('disabled', true);
		} else {
			$('#order-cancel').removeAttr('disabled');
			$('#order-submit').removeAttr('disabled');
		}
	}

	function setValidation() {
		$('.order-content').on('blur','.polident-number-input', function(ev) {
			var $input = $(this);
			var value = $input.val();
			var target = $input.attr('data-input-for'); //chess or table
			var savedValue = $input.attr('data-saved-value');

			// if (this.value) {
			// 	$(this).addClass('touched not-saved');
			// 	$('[data-reset-chess]').removeAttr('disabled');
			// }	


			if (value == savedValue) {
				$input.removeClass('not-saved invalid-input');
				confirmState($input, target);
				return;
			}

			if (value === '') {
				$input.val(savedValue);
				if (savedValue == '') {
					$input.removeClass('touched');
				}

				$input.removeClass('not-saved invalid-input');
				confirmState($input, target);
				return;
			}

			if (value === '0') {
				if (savedValue == '') {
					$input.val(savedValue);
					$input.removeClass('touched not-saved invalid-input');
				} else{
					$input.val(0);
					$input.addClass('touched not-saved');
					$input.removeClass('invalid-input');
				}

				confirmState($input, target);
				return;
			}

			if (isNaN(value) || isNaN(parseInt(value, 10)) || parseInt(value, 10)< 1) {
				$input.addClass('not-saved invalid-input');
				confirmState($input, target);
			} else {
				value = parseInt(value, 10);
				value = value > 9999 ? 9999 : value;
				$input.val(value);
				$input.addClass('touched not-saved');
				$input.removeClass('invalid-input');
				confirmState($input, target);
			}

			$input.attr('data-previous-value', value)
		});

		function confirmState($input, target) {
			if (target == 'chess') {
				var $table = $input.closest('table');
				var numberOfNotSaved = $table.find('.not-saved').length;
				var numberOfInvalid = $table.find('.invalid-input').length;
			
				if (!numberOfInvalid && numberOfNotSaved) {
					$('[data-save-chess]').removeAttr('disabled');
				} else {
					$('[data-save-chess]').attr('disabled', true);
				}
			} else {

				$('#add-other-product-btn').removeAttr('disabled');
				$('#add-disc-btn').removeAttr('disabled');
			}
		}
	}

	function setInitialStateForIntro() {
		$('.session-list-no-content').each(function(index, item) {
			var $item = $(item);
			var type = $item.attr('data-type');

			if (!$item.hasClass('d-none')) {
				$('[data-clear-all-from-session="'+type+'"]').attr('disabled', true);
			}
		})
	}

	function clearAllFromSession() {
		$('[data-clear-all-from-session]').on('click', function(ev) {
			ev.preventDefault();

			var $btn = $(this);
			var $selectionContent = $btn.closest('.selection-content');

			confirm($btn, () => {
				var type = $btn.attr('data-clear-all-from-session');

				var opts = {
					'func': 'clear-all-from-session',
					'type': type
				};
	
				$.post('/util/orderresponse.php?lng='+lng, opts, function(data) {
					$selectionContent.find('.data-row').remove();
					$selectionContent.find('.session-list-has-content').addClass('d-none');
					$selectionContent.find('.session-list-no-content').removeClass('d-none');
	
					$btn.attr('disabled', true);
					updateArticleNumber($selectionContent);
					updateSubmitAndCancelOrderBtn();

				});
			});
		})
	}

	function clearAllFromSessionAndReload() {
		$('#body-content').on('click', '[data-clear-all-from-session-and-reload]', function(ev) {

			ev.preventDefault();

			var $btn = $(this);
			confirm($btn, () => {
				var opts = {
					'func': 'clear-all-from-session-and-reload',
					'type': 'other-product',
					'filter': {
						'product-name': $productName.val(),
						'product-code': $productCode.val()
					}
				};
	
	
				$.post('/util/orderresponse.php?lng='+lng, opts, function(data) {
					$('.other-products-content-wrapper').html(data);
	
				});	
			})

			
		})
	}

	function setSelectionDropdownPanels() {
		$('.selection-panel-wrapper').on('click', function(ev) {
			const $anchor = $(this);
			const target = $anchor.attr('data-selection-anchor');

			const $target = $('[data-selection-content="'+target+'"]');

			if ($target.hasClass('not-shown')) {
				$target.show(0, function() {
					$target.removeClass('not-shown');
				});
				$anchor.find('.fa-angle-down').addClass('d-none');
				$anchor.find('.fa-angle-up').removeClass('d-none');
			} else {
				$target.hide(0, function() {
					$target.addClass('not-shown');
				});
				$anchor.find('.fa-angle-down').removeClass('d-none');
				$anchor.find('.fa-angle-up').addClass('d-none');
			}
		});
	}

	function setTeethProgramArticleSwitch() {
		const $teethProgramSelect = $("#teeth-program-select");
		const strId = $(".order-teeth-wrapper").attr('data-str-id');
		const $teethArticleSelect = $("#teeth-article-select");
		const $teethSelectionWrapper = $('.teeth-selection-wrapper');

		$teethProgramSelect.on('change', function() {
			
			if (this.value) {
				const options = {
					func: 'teeth-program-articles',
					programId: this.value
				}
				$teethArticleSelect.attr('disabled', true);
				$teethSelectionWrapper.hide(0);
				$.post('/util/orderresponse.php?lng='+lng+'&str='+strId, options, function(data) {
					$teethArticleSelect.html(data);
					$teethArticleSelect.removeAttr('disabled');
				})
			}
			
		});

		$teethArticleSelect.on('change', function() {
			if (this.value) {
				const options = {
					func: 'teeth-article',
					articleId: this.value
				};

				$teethSelectionWrapper.hide(0);
				$.post('/util/orderresponse.php?lng='+lng+'&str='+strId, options, function(data) {
					$teethSelectionWrapper.html(data);
					$teethSelectionWrapper.show(0);

					chessMove();
					
					makeTableStickyHeader();

				});
			}
		})
	}
	
	function chessMove() {
		var $chessContent = $('.chess-content');

		if ($chessContent.length) {
			var xList = $chessContent.attr('data-x-list').split(',');
			var yList = $chessContent.attr('data-y-list').split(',');
			$chessContent.find('.polident-number-input').on('keydown', function(ev) {
				var $input = $(this);
				var $td = $input.closest('td');
				var x = $td.attr('data-x');
				var y = $td.attr('data-y');

				switch (ev.keyCode ) {
					case 37:
						var $selectedInput = moveLeft(x, y);
						if ($selectedInput) {
							unhighlightAll('mouseover');
							unhighlightElement($td);
							highlightElement($selectedInput.closest('td'), 'keydown');
						}
					break;
					case 38:
						$selectedInput = moveUp(x, y);
						if ($selectedInput) {
							unhighlightAll('mouseover');
							unhighlightElement($td);
							highlightElement($selectedInput.closest('td'), 'keydown');
						}
					break;
					case 39:
						$selectedInput = moveRight(x, y);
						if ($selectedInput) {
							unhighlightAll('mouseover');
							unhighlightElement($td);
							highlightElement($selectedInput.closest('td'), 'keydown');
						}
					break;
					case 40:
						$selectedInput = moveDown(x, y);
						if ($selectedInput) {
							unhighlightAll('mouseover');
							unhighlightElement($td);
							highlightElement($selectedInput.closest('td'), 'keydown');
						}
					break;
				}
			})
		} 

		function findItemIndex(list, item) {
			for (var i = 0; i< list.length; i++) {
				if ((list[i] == item) ||( list[i] == 'LINE-'+item)) {
					return i;
				}
			}
			return -1;
		}

		function moveLeft(x, y){
			var currentIndex = findItemIndex(xList, x);
			if (currentIndex != 0) {
				var newIndex = currentIndex - 1;
				var $selected = $('td[data-x="'+xList[newIndex]+'"][data-y="'+y+'"] .polident-number-input');
				$selected.focus();
				return $selected;
			}
		}

		function moveRight(x, y){
			var currentIndex = findItemIndex(xList, x);
			if (currentIndex != xList.length-1) {
				var newIndex = currentIndex + 1;
				var $selected = $('td[data-x="'+xList[newIndex]+'"][data-y="'+y+'"] .polident-number-input');
				$selected.focus();
				return $selected;
			}
		}
		function moveUp(x, y) {
			var currentIndex = findItemIndex(yList, y);;
			if (currentIndex != 0) {
				var newIndex = currentIndex - 1;

				var yValue = yList[newIndex];
				yValue = yValue.replace('LINE-','');
				var $selected = $('td[data-x="'+x+'"][data-y="'+yValue+'"] .polident-number-input');
				$selected.focus();
				return $selected;
			}
		}
		function moveDown(x, y) {
			var currentIndex = findItemIndex(yList, y);
			if (currentIndex != yList.length - 1) {
				var newIndex = currentIndex + 1;
				
				var yValue = yList[newIndex];
				yValue = yValue.replace('LINE-','');
				var $selected = $('td[data-x="'+x+'"][data-y="'+yValue+'"] .polident-number-input');
				$selected.focus();
				return $selected;
			}
		}
	}

	function setDiscDropdownsSwitch() {
		const $discCategorySelect = $("#disc-category-select");
		const strId = $(".order-disc-wrapper").attr('data-str-id');
		const $discSelect = $("#disc-select");
		const $discSelectionWrapper = $('.disc-selection-wrapper');

		$discCategorySelect.on('change', function() {
			if (this.value) {
				const options = {
					func: 'disc-category-discs',
					categoryId: this.value
				}
				$discSelectionWrapper.hide(0);
				$discSelect.attr('disabled', true);
				$.post('/util/orderresponse.php?lng='+lng+'&str='+strId, options, function(data) {
					$discSelect.html(data);
					$discSelect.removeAttr('disabled');
				});
			}
			
		});

		$discSelect.on('change', function() {
			if (this.value) {
				const options = {
					func: 'disc-article',
					discId: this.value
				};

				$discSelectionWrapper.hide(0);
				$.post('/util/orderresponse.php?lng='+lng+'&str='+strId, options, function(data) {
					$discSelectionWrapper.html(data);
					$discSelectionWrapper.show(0);
				});
			}
		})
	}

	function setTableHighlight() {
		$('.teeth-selection-wrapper, .disc-selection-wrapper').on('mouseover', 'td', function() {
			const $td = $(this);
			unhighlightAll('keydown');
			highlightElement($td, 'mouseover');
			
		});
		$('.teeth-selection-wrapper, .disc-selection-wrapper').on('mouseout', 'td', function() {
			const $td = $(this);
			unhighlightElement($td);
		
		});
	}

	function setProductAutocomplete() {
		$("[name=\"product-name\"]").autocomplete({
			source: "/util/orderresponse.php?func=autocomplete&lng=" + pageLng,
			minLength: 3,
			max: 10,
			
			create: function() {
				$(this).data('ui-autocomplete')._renderItem = function (ul, item) {
					var re = new RegExp( "(" + this.term + ")", "gi" ),
						cls = this.options.highlightClass,
						template = "<strong>$1</strong>",
						label = item.label.replace( re, template ),
						$li = $( "<li/>" ).appendTo( ul );
			
					// Create and return the custom menu item content.
					$( "<span/>" ).html( label ).appendTo( $li );
					
					return $li;
					  
				}
	
			},
			select: function(hi, ho) {
				setTimeout(() => {
					var options = {
						'func': 'filter-other-products',
						'product-name': $productName.val(),
						'product-code': $productCode.val()
					};
		
					$.post('/util/orderresponse.php?lng='+lng, options, function(data){
						$otherProductCntWrapper.html(data);
					});
				}, 200);
				
			}
	
		});
	}

	function setProductFilter() {

		$('#product-filter-submit').on('click', function(ev) {
			ev.preventDefault();

			var options = {
				'func': 'filter-other-products',
				'product-name': $productName.val(),
				'product-code': $productCode.val()
			};

			$.post('/util/orderresponse.php?lng='+lng, options, function(data){
				$otherProductCntWrapper.html(data);
			});
		});
	}

	function setDiscFilter() {
		$('#disc-filter-submit').on('click', function(ev) {
			ev.preventDefault();

			var options = {
				'func': 'filter-disc',
				'category': $categorySelect.val(),
				'shade': $shadeSelect.val(),
				'thickness': $thicknessSelect.val(),
				'diameter': $diameterSelect.val(),
				'border': $borderSelect.val()
			};

			$.post('/util/orderresponse.php?lng='+lng, options, function(data){
				$discCntWrapper.html(data);
			});
		})
	}

	function handleSaveToSession() {

		handleOtherProductSaving();

		// TEETH / DISC
		handleTeethDiscSaving();

		handleDiscSaving();

		function handleDiscSaving() {
			$('.order-content').on('click', '#add-disc-btn:not(.disabled)', function(ev) {
				ev.preventDefault();
	
				var $btn = $(this);

				confirm($btn, () => {

					var changed = [];
					var $inputs = $('input.not-saved');
					$inputs.each(function(index, item) {
						var $input = $(item);
						var id = $input.attr('name');
						var value = $input.val();
						changed.push({
							id: id,
							value: value
						});
					});

		
					var opts = {
						'func': 'save-to-session',
						'type': 'disc',
						'filter': {
							'category': $categorySelect.val(),
							'shade': $shadeSelect.val(),
							'thickness': $thicknessSelect.val(),
							'diameter': $diameterSelect.val(),
							'border': $borderSelect.val()
						},
						'data': changed
					};

					$.post('/util/orderresponse.php?lng='+lng, opts, function(data) {
						$('.disc-content-wrapper').html(data);

						promptStayLeaveAction();
					});
				});
			});
	
			$('.order-content').on('click', '[data-remove-disc]:not(.disabled)', function(ev) {
				ev.preventDefault();
	
				var $btn = $(this);
	
				confirm($btn, () => {
					var $input = $btn.closest('tr').find('input.disc-quantity');
	
					var id = $btn.attr('data-remove-disc');
		
					var opts = {
						'func': 'clear-from-session',
						'type': 'disc',
						'id': id
					};
					$.post('/util/orderresponse.php?lng='+lng, opts, function(ev) {
						$input.closest('tr').remove();

						var $inputsExist = $('.already-selected-disc input').length > 0;
						if (!$inputsExist) {
							$('.already-selected-disc').remove();
							$('#remove-disc-btn').attr('disabled', true);
						}
					});
				});
			});
		}

		function handleOtherProductSaving() {
			// $('.order-content').on('change', '.polident-number-input', function(ev) {
			// 	$(this).addClass('not-saved');
			// })


			$('.order-content').on('click', '#add-other-product-btn:not(.disabled)', function(ev) {
				ev.preventDefault();
	
				var $btn = $(this);

				confirm($btn, () => {
					// var $td = $btn.closest('tr');
				
					// var $input = $td.find('input.other-product-quantity');
	
					// var $removeBtn = $td.find('[data-remove-other-product]');
	
					// var id = $input.attr('name');
					// var value = $input.val();

					var changed = [];
					var $inputs = $('input.not-saved');
					$inputs.each(function(index, item) {
						var $input = $(item);
						var id = $input.attr('name');
						var value = $input.val();
						changed.push({
							id: id,
							value: value
						});
					});

		
					var opts = {
						'func': 'save-to-session',
						'type': 'other-product',
						'filter': {
							'product-name': $productName.val(),
							'product-code': $productCode.val()
						},
						'data': changed
					};

					$.post('/util/orderresponse.php?lng='+lng, opts, function(data) {
						$('.other-products-content-wrapper').html(data);

						promptStayLeaveAction();
					});
				});
			});
	
			$('.order-content').on('click', '[data-remove-other-product]:not(.disabled)', function(ev) {
				ev.preventDefault();
	
				var $btn = $(this);
	
				confirm($btn, () => {
					var $input = $btn.closest('tr').find('input.other-product-quantity');
	
					var id = $btn.attr('data-remove-other-product');
		
					var opts = {
						'func': 'clear-from-session',
						'type': 'other-product',
						'id': id
					};
					$.post('/util/orderresponse.php?lng='+lng, opts, function(ev) {
						$input.closest('tr').remove();

						var $inputsExist = $('.already-selected-other-products input').length > 0;
						if (!$inputsExist) {
							$('.already-selected-other-products').remove();
							$('#remove-other-product-btn').attr('disabled', true);
						}

					});
				});
			});
		}


		function handleTeethDiscSaving() {

			//saving
			$('.order-teeth-wrapper, .order-disc-wrapper').on('click', '[data-save-chess]', function(ev) {
				ev.preventDefault();

				var $btn = $(this);

				confirm($btn, () => {
					var type = $btn.attr('data-save-chess');
					var $table = $('table.chess-table:not(.copy)');
					var id = $table.attr('data-id');
	
					var options = {
						'func': 'save-to-session',
						'type': type,
						'data': {
							'id': id,
							'value': getChessValue($table)
						}
					};

	
					$.post('/util/orderresponse.php?lng='+lng, options, function(data) {
						$table.find('input.not-saved').each(function(index, input) {
							var $input = $(input);
							var value = $input.val();
							if (value == '0') {
								value = '';
								$input.val(value);
							}
							$input.attr('data-saved-value', value);
							$input.removeClass('not-saved');
						});
						$btn.attr('disabled', true);
						$('[data-reset-chess]').removeAttr('disabled');

						promptStayLeaveAction();
					});
				});
			});

			// reseting
			$('.order-teeth-wrapper, .order-disc-wrapper').on('click', '[data-reset-chess]', function(ev) {
				ev.preventDefault();
				
				var $btn = $(this);

				confirm($btn, () => {
					var type = $btn.attr('data-reset-chess');
					var $table = $('table.chess-table:not(.copy)');
					var id = $table.attr('data-id');
	
					var options = {
						'func': 'clear-from-session',
						'type': type,
						'id': id
					}
	
					$.post('/util/orderresponse.php?lng='+lng, options, function(data) {
						$btn.attr('disabled', true);
						$table.find('input.touched').each(function(index, item) {
							var $item = $(item);
							$item.val('');
							$item.removeClass('touched not-saved');
						})
					});
				});
				
			});

			function getChessValue($table) {
				var values = {};
				$table.find('input.touched').each(function(index, input) {
					var $input = $(input);
					
					var value = $input.val();
					if (value != '' && value != '0') {
						var $td = $input.closest('td');

						var x = $td.attr('data-x');
						var y = $td.attr('data-y');
	
						if (x && y) {
							if (!values[y]) {
								values[y] = {};
							}
							values[y][x] = $input.val();
						}
					}

				
				});
				return values;

			}
		}
	}

	function promptStayLeaveAction() {
		var $orderContent = $('.order-content');

		var message = $orderContent.attr('data-save-success-message');
		var leave = $orderContent.attr('data-leave');
		var stay = $orderContent.attr('data-stay');
		var url = $orderContent.attr('data-url');

		var options = {
			message: message, 
			buttons: {
				confirm: {
					label: leave,
					className: 'btn-polident'
				},
				cancel: {
					label: stay,
					className: 'btn-polident white'
				}
			},
			callback: function (result) {
				if (result == true) {
					window.location.href = url;
				}
			}
		};

		bootbox.confirm(options);
	}

	function confirm($input, callback) {

		var title = $input.attr('data-confirm-title');
		var message = $input.attr('data-confirm-message');

		var $orderContent = $('.order-content');

		var yes = $orderContent.attr('data-yes');
		var no = $orderContent.attr('data-no');

		var options = {
			buttons: {
				confirm: {
					label: yes,
					className: 'btn-polident'
				},
				cancel: {
					label: no,
					className: 'btn-polident white'
				}
			},
			callback: function (result) {
				if (result == true) {
					callback();
				}
			}
		};
		if (title) {
			options.title = title;
		}
		if (message) {
			options.message = message;
		}

		bootbox.confirm(options);
	}

	function highlightElement($element, type) {
		const x = $element.attr('data-x');
		const y = $element.attr('data-y');

		if (x && y) {
			$('[data-x="'+x+'"]').addClass('hovered-td '+ type);
			$('[data-y="'+y+'"]').addClass('hovered-td '+ type);
		}
	}

	function unhighlightElement($element) {
		const x = $element.attr('data-x');
		const y = $element.attr('data-y');

		if (x && y) {
			$('[data-x="'+x+'"]').removeClass('hovered-td');
			$('[data-y="'+y+'"]').removeClass('hovered-td');
		}
	}

	function unhighlightAll(type) {
		$('.hovered-td.'+type).removeClass('hovered-td '+type);
	}


	// ---- Funkcije ankete ----

	// ce obkljuka vsaj 1 stvar v checkBoxi1, odpri checkBoxi2
	$(document).ready(function () {
		// hack, ce pride nazaj in je ze nekej obkljukano
		if (jQuery('#radio_2021111009483505 input[type="radio"]:checked').length > 0) {
			$("#radio_2021111009483522").show();
			$("#radio_2021111009483522 input").prop('required',true).attr('data-required-error',alert);
			$("#checkBoxi3").show();
			$("#checkBoxi3 input").prop('required',true).attr('data-required-error',alert);
		} else {
			$("#radio_2021111009483522").hide();
			$("#radio_2021111009483522").hide();
			$("#radio_2021111009483522 input").prop('required',false).removeAttr('data-required-error');
			$("#checkBoxi3").hide();
			$("#checkBoxi3 input").prop('required',false).removeAttr('data-required-error');
			$("#checkBoxi3 input").prop('checked', false);
		}

		var alert = null;
		if (pageLng == 'slo') {
			alert = 'Izpolnite obvezno polje';
		} else if (pageLng == 'ita') {
			alert = 'Riempire il campo obbligatorio';
		} else if (pageLng == 'deu') {
			alert = 'Füllen Sie das Pflichtfeld';
		} else {
			alert = 'Fill the obligatory field';
		}
		$("#radio_2021111009483522 input").prop('required',false).removeAttr('data-required-error');
		$("#checkBoxi3 input").prop('required',false).removeAttr('data-required-error');

		$('#radio_2021111009483505 input[type="radio"]').click(function () {			
			var show = jQuery('#form_2021011914394573')[0].checked;

			if (show) {
				$("#radio_2021111009483522").show();
				$("#radio_2021111009483522 input").prop('required',true).attr('data-required-error',alert);
				$("#checkBoxi3").show();
				$("#checkBoxi3 input").prop('required',true).attr('data-required-error',alert);
			}else{
				$("#radio_2021111009483522").hide();
				$("#radio_2021111009483522 input").prop('required',false).removeAttr('data-required-error');
				$("#radio_2021111009483522 input").prop('checked', false);
				$("#checkBoxi3").hide();
				$("#checkBoxi3 input").prop('required',false).removeAttr('data-required-error');
				$("#checkBoxi3 input").prop('checked', false);
			}
		});
		
		$('#checkBoxi3 input[type="checkbox"]').click(function () {	
			if($('#checkBoxi3 input[type="checkbox"]:checked').length) {
				$("#checkBoxi3 input").prop('required',false).removeAttr('data-required-error');
			} else {
				$("#checkBoxi3 input").prop('required',true).attr('data-required-error',alert);
			}
		});
	});

	// ce obkljuka vsaj 1 stvar v checkBoxi2, odpri textAreaAnketa
	/*$(document).ready(function () {
		// hack, ce pride nazaj in je ze nekej obkljukano
		if (jQuery('#radio_2021111009483522 input[type="radio"]:checked').length > 0) {
			$("#checkBoxi3").show();
		}
		$('#radio_2021111009483522 input[type="radio"]').click(function () {
			if (jQuery('#radio_2021111009483522 input[type="radio"]:checked').length > 0) {
				var b = false;
				$('#checkBoxi2').find('input:radio:first').each(function(el){ 
					if(this.checked){
						b = true;
					}
				});
				if(!b) {
					$("#checkBoxi3").show();
				}
			}
			else {
				$("#checkBoxi3").hide();
			}
		});
	});*/
}

module.exports = orderFunctions;
window.orderFunctions = orderFunctions;
}.call(window, window);